
import React from 'react';
import Layout from '@/components/Layout';

const CoursesUserPage: React.FC = () => {
  return (
    <Layout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold">My Courses</h1>
        <p className="mt-4">View your enrolled courses.</p>
      </div>
    </Layout>
  );
};

export default CoursesUserPage;
